var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16917_7765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 19.1666C15.0613 19.1666 19.1654 15.0625 19.1654 9.99992C19.1654 4.93731 15.0613 0.833252 9.9987 0.833252C4.93609 0.833252 0.832031 4.93731 0.832031 9.99992C0.832031 15.0625 4.93609 19.1666 9.9987 19.1666Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 15.0001V13.889C14.1654 13.2996 13.9459 12.7344 13.5552 12.3176C13.1645 11.9009 12.6346 11.6667 12.082 11.6667H7.91536C7.36283 11.6667 6.83293 11.9009 6.44223 12.3176C6.05152 12.7344 5.83203 13.2996 5.83203 13.889V15.0001",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16675C11.3807 9.16675 12.5 8.04746 12.5 6.66675C12.5 5.28604 11.3807 4.16675 10 4.16675C8.61929 4.16675 7.5 5.28604 7.5 6.66675C7.5 8.04746 8.61929 9.16675 10 9.16675Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16917_7765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3a49e2a3e45bf392bc1fe6ffb18c70f9.svg";
export { ForwardRef as ReactComponent };